import classnames from 'clsx';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { player } from 'src/client/player';
import { useOutsideClickControl } from 'src/common/hooks/useOutsideClickControl';
import { useStores } from 'src/common/providers';
import { selectIsMobile } from 'src/common/selectors/app';
import Popover from '../../shared/Popover';
import PlayBackRateOption from './PlayBackRateOption';
import css from './speed-control.module.scss';

const playbackRateOptions = [0.5, 0.8, 1.0, 1.2, 1.5, 2.0, 3.0];
const mobilePlaybackRateOptions = [0.5, 1.0, 1.5, 2.0];

export default function SpeedControl({ iconContainerClass }) {
  const { playerStore } = useStores();
  const playbackRate = playerStore.playbackRate();
  const { handleOnClick, isOpen, containerRef } = useOutsideClickControl();
  const isMobile = useSelector(selectIsMobile);

  if (isMobile) {
    const handleMobileOnClick = () => {
      const currentIndex = mobilePlaybackRateOptions.indexOf(playbackRate);
      const nextPlaybackRate =
        mobilePlaybackRateOptions[currentIndex + 1] || mobilePlaybackRateOptions[0];

      player.setPlaybackRate(nextPlaybackRate);
    };

    return (
      <div className={iconContainerClass} onClick={handleMobileOnClick}>
        <div className={classnames(css.speedControlText, css.mobileSpeedControlText)}>
          {`${playbackRate}x`}
        </div>
      </div>
    );
  }

  return (
    <div ref={containerRef}>
      <button type="button" className={iconContainerClass} onClick={handleOnClick}>
        <div className={css.speedControlText}>{`${playbackRate}x`}</div>
      </button>
      <Popover isOpen={isOpen} className={css.popover}>
        <div className={css.content}>
          {playbackRateOptions.map((val) => (
            <PlayBackRateOption
              key={val}
              value={val}
              className={css.row}
              dataTestId={`rate-${val}`}
            />
          ))}
        </div>
      </Popover>
    </div>
  );
}

SpeedControl.propTypes = {
  iconContainerClass: PropTypes.string,
};
